const errorEnum: { [key: string]: any } = {
  1: "permission denied",
  2: "position unavalablf",
  3: "timeout",
  4: "unknow error",
}
export const locationDSL = {
  /**
   * 获取经纬度
   */
  async get() {
    return new Promise((reslove, reject) => {
      navigator?.geolocation?.getCurrentPosition(
        (p) => {
          reslove({
            latitude: p.coords.latitude,
            longitude: p.coords.longitude,
          })
        },
        (e) => {
          reject(errorEnum[e.code])
        }
      )
    })
  },
} as LocatioDSL
